import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { QueryParameter } from "@idw-types/common";
import { IdentityProviderChangeRequestDataResponse } from "@idw-types/data/identity-providers";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithQueryParams } from "@utils/http-util";

export const getIdentityProviderChangeRequest = async (
    identityProviderId: string,
): Promise<GenericNetworkResponse<IdentityProviderChangeRequestDataResponse>> => {
    const queryParameters: Array<QueryParameter> = [
        { parameter: "identityProviderID", value: identityProviderId }
    ];

    const { data, error } = await handleRequestWithQueryParams(
        RequestTypes.GET,
        apiRoutes.idpConfiguration.data.identityProviderChangeRequest,
        queryParameters
    );

    return { data, error, queryParameters };
};
